import { Radii, Spacing } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  ThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable } from '@mangovoice/design-system'
import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export enum MangoAlertVariant {
  Success = 'green.solid',
  Error = 'red.solid',
  Loading = 'loading',
  Info = 'info',
  Warning = 'warning',
}

const mangoAlertStyleParts = [
  'container',
  'contentContainer',
  'textContainer',
  'title',
  'description',
  'icon',
  'circleProgress',
  'closeButton',
] as const

const helpers = createMultiStyleConfigHelpers(mangoAlertStyleParts)
export const MangoAlertStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      color: 'brand.contrast',
      minWidth: '12.5rem',
      maxWidth: '22.5rem',
      borderRadius: Radii.lg,
      py: Spacing._3,
      px: Spacing._4,
      userSelect: 'none',
      boxShadow: asChakraVariable({ default: 'shadows.default' }),
    },
    contentContainer: {
      gap: Spacing._3,
    },
    textContainer: {
      gap: 0,
      alignItems: 'start',
    },
    title: {
      ...textStyles[textStyleKeys.Body1_Bold],
    },
    description: {
      ...textStyles[textStyleKeys.Body1],
    },
    icon: {
      color: 'brand.contrast',
      height: '1.5rem',
      width: '1.5rem',
    },
    closeButton: {
      position: 'absolute',
      right: '2',
      top: '2',
    },
    circleProgress: {
      height: '2.0rem',
      width: '6px',
      backgroundColor: 'bg.muted',
      color: 'brand.contrast',
    },
  },
  variants: {
    [MangoAlertVariant.Success]: {
      container: {
        backgroundColor: 'green.solid',
      },
    },
    [MangoAlertVariant.Error]: {
      container: {
        backgroundColor: 'red.solid',
      },
    },
    [MangoAlertVariant.Loading]: {
      container: {
        backgroundColor: 'brand.solid',
      },
    },
    [MangoAlertVariant.Info]: {
      container: {
        backgroundColor: 'brand.solid',
      },
    },
    [MangoAlertVariant.Warning]: {
      container: {
        backgroundColor: 'orange.solid',
      },
    },
  },
})

export const useMangoAlertStyles = (props?: ThemingProps) =>
  mergeMultiStyleConfig(MangoAlertStyle, props) as MultiStyleType<
    typeof mangoAlertStyleParts
  >
